module.exports = __webpack_public_path__ + "media/pokemon-trainer.4f64dd75.wav";